import { Route, Switch } from 'react-router-dom';
import { PageRouterConfig } from '../page-routes';

export const PageRouter = () => {
  return (
    <Switch>
      {Object.entries(PageRouterConfig).map(([key, route]) => (
        <Route key={key} {...route} />
      ))}
    </Switch>
  );
};
